export const logError = (componentName: string, data: any) => {
  console.error(`[${componentName}] error`, JSON.stringify(data));
};

export const formatGraphQLError = (message: string) =>
  message.replace('GraphQL error:', '');
